import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class StatutoryComplianceInformation extends Component {
  constructor() {
    super();
    this.state = {
      submit_button:<button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_emp_basic_details.bind(this)}>Update</button>,
    };
  }


  componentDidMount(){
    this.get_emp_basic_details();
  }
  get_emp_basic_details(){
      var cutThis           = this;
      var emp_id            = cutThis.props.id;
      var web_token         = window.isNullAndUndef($('#web_token').val());
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('web_token',web_token);
      body.append('form_type','employee_statutory_compliance_information');
      body.append('function','get_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          if(data['error']==1){
            var new_data = data['data'];
            cutThis.update_info(new_data);
          }

       })
       .catch(function (error) {
           console.log(error);
       });
  }

  update_info(data){
    $('#user_uan ').val(data['user_uan']);
    $('#pf_nominee').val(data['pf_nominee']);
    $('#esi_number').val(data['esi_number']);
    $('#esi_nominee').val(data['esi_nominee']);
    $('#gratuity_nominee').val(data['gratuity_nominee']);
    $('#pan_number').val(data['pan_number']);
    $('#professional_tax').val(data['professional_tax']);
  }

  add_emp_basic_details(){
    var cutThis           = this;
    var emp_id            = cutThis.props.id;
    var web_token         = window.isNullAndUndef($('#web_token').val());

    var user_uan          = window.isNullAndUndef($('#user_uan').val());
    var pf_nominee        = window.isNullAndUndef($('#pf_nominee').val());
    var esi_number        = window.isNullAndUndef($('#esi_number').val());
    var esi_nominee       = window.isNullAndUndef($('#esi_nominee').val());
    var gratuity_nominee  = window.isNullAndUndef($('#gratuity_nominee').val());
    var pan_number        = window.isNullAndUndef($('#pan_number').val());
    var professional_tax  = window.isNullAndUndef($('#professional_tax').val());


    var submit_button     = <button className="btn btn-primary w-100 py-3" type="button">Update...</button>;
    cutThis.setState({submit_button});
    $('label').removeClass('color_red');
    if(user_uan || pf_nominee || esi_number || esi_nominee || gratuity_nominee || pan_number || professional_tax){
      var all_data                    = {};
      all_data['user_uan']            = window.return_false_null(user_uan);
      all_data['pf_nominee']          = window.return_false_null(pf_nominee);
      all_data['esi_number']          = window.return_false_null(esi_number);
      all_data['esi_nominee']         = window.return_false_null(esi_nominee);
      all_data['gratuity_nominee']    = window.return_false_null(gratuity_nominee);
      all_data['pan_number']          = window.return_false_null(pan_number);
      all_data['professional_tax']    = window.return_false_null(professional_tax);
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('emp_date',JSON.stringify(all_data));
      body.append('web_token',web_token);
      body.append('form_type','employee_statutory_compliance_information');
      body.append('function','add_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          $('#error_msg').text(data['msg']);
          submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
          cutThis.setState({submit_button});
       })
       .catch(function (error) {
           console.log(error);
       });
    }else {
      window.change_lable_color('user_uan','pf_nominee','esi_number','esi_nominee','gratuity_nominee','pan_number','professional_tax');
      submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
      cutThis.setState({submit_button});
    }

  }


  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">
                            <div className="col-md-12">
                            <label for="name">Provident Fund (PF) Details</label>
                            </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="user_uan" placeholder="UAN (Universal Account Number)"/>
                                        <label for="name">UAN (Universal Account Number)</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="pf_nominee" placeholder="PF Nominee Details"/>
                                        <label for="name">PF Nominee Details</label>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                <label for="name">Employee State Insurance (ESI) Details</label>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="esi_number" placeholder="ESI Number (if applicable)"/>
                                        <label for="name">ESI Number (if applicable)</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="esi_nominee" placeholder="ESI Nominee Details"/>
                                        <label for="name">ESI Nominee Details</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="gratuity_nominee" placeholder="Gratuity Nominee Details"/>
                                        <label for="name">Gratuity Nominee Details</label>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                <label for="name">Income Tax Details</label>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="pan_number" placeholder="PAN Number"/>
                                        <label for="name">PAN Number</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="professional_tax" placeholder="Professional Tax Details"/>
                                        <label for="name">Professional Tax Details (if applicable as per state laws)</label>
                                    </div>
                                </div>


                                <div className="col-md-12">
                                <div className="col-md-8">
                                  <p id="error_msg"></p>
                                </div>
                                <div className="col-md-4 p-0 float_r">
                                    {this.state.submit_button}
                                </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default StatutoryComplianceInformation;
